export default __webpack_public_path__ + "static/media/Patient_DP_Upload.cd5e42ef.svg";